import { useCallback } from 'react';
import { useParams } from 'react-router';

import { useRemoveParams } from './useRemoveParams';

export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export default function useUtmParams() {
  // eslint-disable-next-line camelcase
  const utmParams = useParams<UtmParams>();
  const removeParams = useRemoveParams();

  const removeUtmParams = useCallback(
    () => removeParams(['utm_source', 'utm_medium', 'utm_campaign']),
    [removeParams]
  );

  return {
    utmParams: {
      utmSource: utmParams.utm_source,
      utmMedium: utmParams.utm_medium,
      utmCampaign: utmParams.utm_campaign,
    },
    removeUtmParams,
  };
}
